import React from 'react';
import Image from 'next/image';
import { imageTransform } from '@/shared/utils/utils';
import { OfferingType } from '@/shared/types/subscription';
import './index.less';

const OfferingCard = ({ offering }: { offering: OfferingType }) => {
  return (
    <div className="offering-card">
      <div className="top">
        <div className="icon">
          <Image
            src={imageTransform(offering.icon, 'large')}
            width={100}
            height={100}
            alt="Pietra offering"
            title="Pietra offering"
          />
        </div>
        <span className="title">{offering.title}</span>
      </div>
      {offering.description.map((desc, i) => (
        <span key={`desc-${i}`} className="desc">
          {desc}
        </span>
      ))}
    </div>
  );
};

export default OfferingCard;
